import { Card } from 'antd';
import styled from 'styled-components';

export const TemplateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-top: 1px solid #e0e0e0;
`;

// peak dev moment
export const BubbleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding: 10px;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
`;

export const NexaTitle = styled.div`
  font-size: 56px;
  font-weight: 300;
  position: relative;
  display: inline-block;
  line-height: 56px;
`;

export const NexaSubtitle = styled.div`
  font-size: 20px;
  font-weight: 300;
`;

export const TryPromptsTitle = styled.div`
  margin-bottom: 10px;
  text-align: center;
  color: #888;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const StyledCard = styled(Card)`
  box-shadow: 0 4px 16px rgb(0 0 0 / 6%);
  background-color: rgb(255 255 255 / 92%);
`;

export const ViewAllLink = styled.a`
  display: inline-block;
  margin-top: 12px;
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #8c8c8c;

  .ant-empty-description {
    white-space: pre-line;
    line-height: 1.6;
  }
`;
